export default {
    send (name = '', label = '') {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'KEY',
                eventCategory: 'KEY',
                eventLabel: label,
                eventName: name
            })
        }
    },
    getPixel (url) {
        const localUrl = url.replace('%random%', Math.floor(Math.random() * 4294967295) + 1);
        const image = new Image(localUrl);
        image.src = localUrl;
        image.width = 0;
        image.height = 0;
        document.body.appendChild(image);
        image.style.display = 'none'
    },
    getUrl (url) {
        return url.replace('%random%', Math.floor(Math.random() * 4294967295) + 1);
    }
}
